export default __webpack_public_path__ + "static/media/portfolioHero.fde804d7.png";